import * as api from './api'
import { loadInquiry, loadAnswer } from './actions'
import { IInquiry, IAnswer } from './types'

export function requestInquiry(dispatch: any, calculatorId: string, inquiry: any) {
  return api.createInquiry(calculatorId, inquiry).then((inq: IInquiry) => {
    dispatch(
      loadInquiry({
        ...inq,
        ...{
          status: 'CALCULATING'
        }
      })
    )
    return api.obtainAnswer(inq.id).then((answer: IAnswer) => {
      dispatch(loadAnswer(calculatorId, answer))
    })
  })
}
